import mediator from "@tvg/mediator";

interface Payload {
  raceNumber: string;
  trackName: string;
  label: string;
}

export const gtmOnSelectWillPaysOption = ({
  raceNumber,
  trackName,
  label
}: Payload) => {
  mediator.base.dispatch({
    type: "PPM_WILL_PAYS_SELECT_OPTION",
    payload: {
      raceNumber,
      trackName,
      label
    }
  });
};

export const gtmOnSelectProbablesOption = ({
  raceNumber,
  trackName,
  label
}: Payload) => {
  mediator.base.dispatch({
    type: "PPM_PROBABLES_SELECT_OPTION",
    payload: {
      raceNumber,
      trackName,
      label
    }
  });
};
